import React, { useState, useEffect } from "react";
import Form from 'react-bootstrap/Form';
import '../assets/css/home.css';
const MasterLayoutElysiumTower = () => {
    const [value, setValue] = useState(0);

    const images = [
        "/Elysium_Tower/master_layout/master-layout.jpg",
    ];
    useEffect(() => {
        images.forEach((src) => {
            const img = new Image();
            img.src = src;
        });
    }, []);

    return (
        <div className="full-container home_image master-layout">
            <img src={`/Elysium_Tower/master_layout/master-layout.jpg`} alt="" className="" />
        </div>
    )
}

export default MasterLayoutElysiumTower;